<template>
  <div class="manage-screen">
    <h1 class="display-5 mb-1"><b>Manage subscription</b></h1>
    <p class="text-muted mb-4">Review, update, pause or cancel</p>

    <SummaryCard :display="display" class="mb-4" />

    <div class="manage-screen__actions">
      <ActionRow
        v-if="!display.hidesBillingActions"
        title="Update payment method"
        @select="$emit('update-payment')"
      />
      <ActionRow v-if="!display.hidesPauseAction" title="Pause my subscription" @select="$emit('pause')" />
      <!-- A fixed-term grant has nothing to cancel: no store subscription, no
           card on file. The row used to be shown regardless and could only ever
           dead-end at a support hand-off. -->
      <ActionRow
        v-if="!display.hidesBillingActions"
        title="Cancel my subscription"
        @select="$emit('cancel')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import SummaryCard from "./SummaryCard.vue";
import ActionRow from "./ActionRow.vue";
import type { DisplayModel } from "../subscriptionLogic";

defineProps<{ display: DisplayModel }>();
defineEmits<{ (e: "update-payment"): void; (e: "pause"): void; (e: "cancel"): void }>();
</script>
